import React from 'react';
import { Box } from '@mui/material';
import AlarmsTable from '../../../../../components/AlarmsTable';
import { getLocationId } from '../../../utils/locationTransformers';

const AlarmsTab = ({ selectedLocation }) => {
  const locationId = getLocationId(selectedLocation);

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <AlarmsTable
        locationId={locationId}
        onViewAlarm={(alarm) => {
          window.location.href = `/alarms?selectedId=${alarm.id}`;
        }}
      />
    </Box>
  );
};

export default AlarmsTab;
